import './date-picker.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Calendar } from 'react-date-range';
import theme from '../calendar/calendar-theme-rewrite';
import Toggle from '../toggle';

const DatePicker = props => {
	return (
		<div className="calendar-wrap date-picker-wrap">
			<Toggle
				head={
					<div
						className={cn('calendar-wrap__head', props.isOpen && 'is-open')}
						onClick={ e => props.onToggle() }>
						<span className="selected-value">{ props.formattedDate }</span>
					</div>
				}
				isShow={props.isOpen}
				onOutSideClick={e => props.onToggle()}>
				<div className="calendar-wrap__body">
					<Calendar
						date={props.date}
						onChange={props.onChange || props.onUpdate}
						theme={theme}
						minDate={props.minDate}
						{...(props.maxDate ? { maxDate: props.maxDate } : {})}
					/>
					<div className="calendar-wrap__body-btn">
						<a
							href="javascript:;"
							className="apply font-roboto-medium"
							onClick={ e => props.onApply() }>{ props.intl('Apply') }</a>
					</div>
				</div>
			</Toggle>
		</div>
	);
};

DatePicker.propTypes = {
	onToggle: PropTypes.func,
	onChange: PropTypes.func,
	onApply: PropTypes.func,
	componentName: PropTypes.string,
	isOpen: PropTypes.bool,
	date: PropTypes.any,
	minDate: PropTypes.any,
	formattedDate: PropTypes.string,
	intl: PropTypes.func
};

export default DatePicker;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/date-picker/main.js